import './content.scss';

import { PropsWithChildren } from 'react';

type ContentProps = PropsWithChildren<{
  toolbar?: JSX.Element | string;
}>;

export function Content({ toolbar, ...props }: ContentProps) {
  return (
    <div className="content">
      {toolbar && <div className="content__toolbar">{toolbar}</div>}
      <div className="content__content">{props.children}</div>
    </div>
  );
}
